import { useEffect, useState } from 'react';
import useGetPostCode from './useGetPostCode';
import { useGetCarDetails } from '../../productCatalog/react/useGetCarDetails';
import { ICarDetails } from '../../../../common/model/ICarDetails';
import { ICustomerData } from '../../../../common/model/ICustomerData';
import useCustomerStorage from '../hooks/useCustomerStorage';

export interface IFinCalcSpcInitConfig extends Partial<ICarDetails> {
  postCode: string | string[];
  dealerId: string;
}

interface IFinCalcSpcInitState {
  finCalcSpcInitConfig: IFinCalcSpcInitConfig;
  isConfigLoading?: boolean;
}

export const useGetFinCalcSpcInitConfig: (isCallNeeded?: boolean, carId?: string) => IFinCalcSpcInitState = (
  isCallNeeded = false,
  carId = '',
) => {
  const postCode: string | null = useGetPostCode();
  const { isLoading: carDetailsAreLoading, response } = useGetCarDetails(isCallNeeded, carId, postCode);
  const { customerStorage } = useCustomerStorage();
  const customerData: ICustomerData = customerStorage.getCustomerData();
  const dealerId: string = customerData?.dealerId ?? '';

  const [state, setState] = useState<IFinCalcSpcInitState>({
    finCalcSpcInitConfig: { postCode, dealerId },
    isConfigLoading: false,
  });

  useEffect(() => {
    if (response) {
      setState({
        finCalcSpcInitConfig: { ...response, postCode, dealerId },
        isConfigLoading: carDetailsAreLoading,
      });
    }
  }, [response]);

  return { ...state };
};
